import React from 'react';
import AssociateTenants from '../AssociateTenants';
import type { AssociateTenantsProps } from '../AssociateTenants';
import MspChildModeSelect from '../parts/MspChildModeSelect/MspChildModeSelect';
import MspParentModeSelect from '../parts/MspParentModeSelect/MspParentModeSelect';
import type { ResolvedAssociationFlow } from './getAssociationFlow';

// The drawer entry needs customerId for the MSSP Parent flow (children
// lookup); AssociateTenants itself never uses it.
export type AssociationDrawerProps = AssociateTenantsProps & {
  customerId: string;
};

export const renderAssociationDrawer = (
  flow: ResolvedAssociationFlow,
  props: AssociationDrawerProps
): React.ReactElement => {
  switch (flow) {
    case 'smb':
      return <AssociateTenants {...props} />;
    case 'mspChild':
      return (
        <MspChildModeSelect
          tenantId={props.tenantId}
          companyName={props.companyName}
          updateDataFn={props.updateDataFn}
        />
      );
    case 'mspParent':
      return (
        <MspParentModeSelect
          customerId={props.customerId}
          tenantId={props.tenantId}
          companyName={props.companyName}
          updateDataFn={props.updateDataFn}
        />
      );
    default:
      throw new Error(`Unhandled association flow: ${JSON.stringify(flow)}`);
  }
};
